import React, { useMemo, memo } from "react";
import { useTranslation } from "react-i18next";

import { useAppContext } from "../../../../../../../../../context";
import { StyledRow } from "../../../../../../../../../components/common";
import { OrderFormProps } from "../../../types/FormProps";
import { Gray, Primary } from "../../styled";
import { ConstantFormat } from "../../../../../../../../../utils/DateFns";

const ArrivalTime: React.FC<ArrivalTime.Props> = ({ tab }) => {
	const { t } = useTranslation();
	const { dateFns } = useAppContext();

	const lastReceivedOrder = useMemo(
		() => tab?.form?.transfer?.lastReceivedOrder,
		[tab?.form?.transfer?.lastReceivedOrder],
	);

	const arrivalTransfer = useMemo(
		() =>
			lastReceivedOrder?.executorToOrder?.at(0)?.additionalFields
				?.arrivalTime,
		[lastReceivedOrder?.executorToOrder],
	);

	const arrival = useMemo(
		() => tab?.form?.arrivalTime || arrivalTransfer,
		[tab?.form?.arrivalTime, arrivalTransfer],
	);
	const arrivalTime = useMemo(() => {
		if (arrival) {
			const time = dateFns.formatTime2(arrival, ConstantFormat.HMS_UK, {
				timezone: dateFns.timezone,
			});
			const date = dateFns.formatTime2(arrival, ConstantFormat.MDY_UK, {
				timezone: dateFns.timezone,
			});
			return { time, date };
		}
		return { time: "-", date: "" };
	}, [arrival, dateFns]);

	return (
		<StyledRow gap="0 6px">
			<Primary>
				{`${t([`orderPage.order_form.is_feed`, "Innings"])}:`}
			</Primary>
			<Gray>{arrivalTime.date}</Gray>
			<Primary>{arrivalTime.time}</Primary>
		</StyledRow>
	);
};

declare namespace ArrivalTime {
	interface Props extends OrderFormProps {}
}
export const ArrivalTimeMemo = memo(ArrivalTime);
export default ArrivalTime;
